import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer'

const useAllRelationFolderBookIdsByBook = (bookId: string | undefined) : string[] => {
  const relationFolderBookDb = useSelector((state: RootState) => state.relationFolderBookDb)
  const ids = Object.keys(relationFolderBookDb.relationFolderBooks).filter(id => relationFolderBookDb.relationFolderBooks[id].bookId === bookId)

  return ids
}

export default useAllRelationFolderBookIdsByBook
